export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/833d0d56-2379-4fed-8508-df8fc13910a7/product-uploads/'

export const insideItems: string[] = [
  'Tooth structure cross-sections',
  'Universal, FDI & Palmer numbering',
  'Tooth-by-tooth morphology',
  'Eruption timelines',
  'Occlusion & TMJ',
  'Clinical examination sequences',
  'Oral lesion description guides',
  'Caries detection & classification',
  'Normal radiographic anatomy',
  'Radiograph technique errors',
  'Instrument grasps & fulcrums',
  'Rubber dam isolation',
  'Class I to Class V preparations',
  'Etching & bonding step by step',
  'Dental materials comparisons',
  'Access & working length',
  'Periodontal probing & charting',
  'Scaling & root planing',
  'Local anesthetic agents & doses',
  'Nerve block landmarks',
  'Extraction step by step',
  'Suturing basics',
  'Medical emergency protocols',
  'Infection control checklists',
  'Clinical demonstration method',
  'Lesson & program plans',
  'Competency checklists & rubrics',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
  'Simulation lab exercises',
]

/** Carousel slides — one real page per volume (Vol 1 to Vol 6). */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_ccb5bdaa-85e3-4e7b-8525-50affe77d113_1793748644703.jpg`,
    alt: 'Dental Instructor Atlas — Vol 1 page: Tooth Structure Cross-Section from crown to apex, with labeled enamel, dentin, pulp, cementum, PDL and alveolar bone',
    title: 'Vol 1 — Tooth Structure Cross-Section',
    caption: 'Vol 1 — Dental Anatomy, Oral Histology & Tooth Morphology: a labeled cross-section from crown to apex, with an instructor cue, a 10-minute drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_96c6898b-b2e1-48d2-92ca-3332d4d850af_1793748647179.jpg`,
    alt: 'Dental Instructor Atlas — Vol 2 page: Normal Radiographic Anatomy, key maxillary and mandibular landmarks on a panoramic radiograph',
    title: 'Vol 2 — Normal Radiographic Anatomy',
    caption: 'Vol 2 — Oral Pathology, Dental Radiology & Clinical Diagnosis: key maxillary and mandibular landmarks, an instructor cue, a labeling drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_4442fa5a-4780-4858-8668-a9c44d5467c6_1793748649680.jpg`,
    alt: 'Dental Instructor Atlas — Vol 3 page: Class I Preparation, occlusal pit-and-fissure preparation in 5 steps, amalgam vs. composite outline',
    title: 'Vol 3 — Class I Preparation',
    caption: 'Vol 3 — Restorative Dentistry, Dental Materials & Operative Techniques: a 5-step Class I preparation, amalgam vs. composite outlines, ❌/✅, a typodont drill and Easy / Standard / Advanced levels.',
  },
  {
    src: `${IMG_BASE}mcp_f3a63b58-07c3-4d32-aab8-8cefdf2adc9a_1793748652122.jpg`,
    alt: 'Dental Instructor Atlas — Vol 4 page: Periodontal Probing Technique, the walking stroke and 6-step technique',
    title: 'Vol 4 — Periodontal Probing Technique',
    caption: 'Vol 4 — Endodontics, Periodontics & Clinical Treatment Procedures: the walking stroke, a 6-step probing technique, ❌/✅, an instructor cue, a paired drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_d01ee756-6476-4950-bf78-a7d1a8504422_1793748659288.jpg`,
    alt: 'Dental Instructor Atlas — Vol 5 page: Inferior Alveolar Nerve Block, labeled landmarks, insertion point and areas anesthetized',
    title: 'Vol 5 — Inferior Alveolar Nerve Block',
    caption: 'Vol 5 — Oral Surgery, Local Anesthesia & Patient Management: labeled landmarks, insertion and aspiration steps, areas anesthetized, ❌/✅ and an instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_1db6ac14-2115-464e-a905-9316cb2313b6_1793748661785.jpg`,
    alt: 'Dental Instructor Atlas — Vol 6 page: The 5-Step Clinical Demonstration Method for teaching any clinical skill',
    title: 'Vol 6 — The 5-Step Clinical Demonstration Method',
    caption: 'Vol 6 — Dental Clinical Instruction, Teaching Programs & Practical Assessments: a 5-step sequence for teaching any clinical skill, an instructor cue and a paired drill.',
  },
]
